import Repository from '../../../Repository';

const resource = '/shopify/store-properties';

export default {
  getShippingZones(region) {
    return Repository.get(`${resource}/shipping-zone`, {
      params: {
        region,
      },
    });
  },
};
